import AppConstants from '../constants/AppConstants';
import { AxiosAccountClient } from '../proxy/ProxyClients';

// const api = new AccountApi(new Configuration({ basePath: AppConstants.BASE_API_URL }));
// const api = new Client(AppConstants.BASE_API_URL, configureAxios());

const AccountService = {
  confirmEmail: (email: string, token: string) => AxiosAccountClient.confirmEmail({
    code: token,
    email
  }),
  resetPassword: (email: string, password: string, token: string) => AxiosAccountClient.resetPassword({
    email,
    newPassword: password,
    passwordResetToken: token
  }),
  sendResetPasswordLink: (email: string) => AxiosAccountClient.forgotPassword({
    email
  }),
  changePassword: (oldPassword: string, newPassword: string) => AxiosAccountClient.changePassword({
    oldPassword,
    newPassword
  })
};

export default AccountService;
